export default __webpack_public_path__ + "static/media/alur-5.e92026c9.png";